<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const {
  data,
  search,
  searchDialogOpen,
  searchElement,
  searchInput,
  closeDialog,

  onKeyPressElement,
  onKeyPressWindow,
  doSearch,

  currentFocusIndex,
} = useQuickSearch()

const router = useRouter()
router.beforeEach(() => {
  closeDialog()
})

watch(search, () => {
  if (search.value) {
    searchDialogOpen.value = true
  }
  else {
    data.value = null
  }
  currentFocusIndex.value = -1
})

onMounted(() => {
  window.addEventListener('keyup', onKeyPressWindow)
})

onUnmounted(() => {
  window.removeEventListener('keyup', onKeyPressWindow)
})

onClickOutside(searchElement, () => closeDialog())
</script>

<template>
  <search
    :ref="(el) => searchElement = el"
    class="search"
    :class="{ 'search--active': searchDialogOpen }"
    @keydown="onKeyPressElement"
  >
    <!-- <div :aria-modal="searchDialogOpen ? 'true' : 'false'"> -->
    
<FormKitLazyProvider>
<div>
      <FormKit
        id="search__form"
        name="search__form"
        form-class="search__form"
        type="form"
        :actions="false"
        @submit="doSearch"
      >
        <!-- Fixes broken reactivity on Android Chrome -->
        <input
          :ref="(el) => searchInput = el"
          :value="search"
          type="search"
          class="formkit-input"
          data-testid="quicksearch"
          role="combobox"
          aria-describedby="search-help"
          aria-haspopup="listbox"
          :aria-label="$t('Searching for ...')"
          :aria-expanded="searchDialogOpen ? 'true' : 'false'"
          :placeholder="$t('Searching for ...')"
          @input="(e) => search = (e.target as HTMLInputElement).value"
          @focus="searchDialogOpen = true"
        >

        <button
          type="button"
          class="search__close"
          :aria-label="$t('Close')"
          @click="closeDialog()"
        >
          <span class="search__close-label">{{ $t('Close') }}</span>
          <NuxtIcon
            name="icon:chevron"
            class="icon:chevron--left"
          />
        </button>

        <div class="search__actions">
          <button
            v-if="search.length > 0"
            type="button"
            class="search__reset"
            @click="search = ''"
          >
            <NuxtIcon name="icon:close-round" />
          </button>

          <span
            v-if="search.length > 0"
            class="search__divider"
            aria-hidden="true"
          />

          <button
            :aria-label="$t('Search')"
            type="submit"
            class="search__submit"
          >
            <NuxtIcon
              name="icon:search"
              aria-hidden="true"
            />
          </button>
        </div>

        <div
          id="search-help"
          class="search__help"
        >
          {{ $t('Search begins after typing 3 characters. Use arrow keys to navigate results.') }}
        </div>
      </FormKit>

      <SearchPanel v-if="searchDialogOpen" />
    </div>
</FormKitLazyProvider>

  </search>
</template>

<style>
@import url("~layers/components/Search/Component.css");
</style>
